var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.3513H55.6487V86.9999H0V31.3513Z",
    fill: "#171C8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2972 31.3513C24.2972 14.0365 38.3337 0 55.6486 0C72.9634 0 86.9999 14.0365 86.9999 31.3513C86.9999 48.6662 72.9634 62.7027 55.6486 62.7027C38.3337 62.7027 24.2972 48.6662 24.2972 31.3513Z",
    fill: "#256BE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2972 31.3513C24.2972 31.3513 24.2972 31.3514 24.2972 31.3513C24.2972 48.6662 38.3337 62.7027 55.6486 62.7027C55.6486 62.7027 55.6486 62.7027 55.6486 62.7027L55.6487 31.3513L24.2972 31.3513Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareCircle);
export default __webpack_public_path__ + "static/media/square-circle.af1a122caeecbcf50f67faf2dba11f9a.svg";
export { ForwardRef as ReactComponent };